import NotFound from '@/components/not-found/not-found';

export default NotFound;
